'use strict'
if (typeof window === 'undefined') global.window = global

global.regeneratorRuntime = require('regenerator-runtime/runtime')

module.exports = () => ({})
